import { useRoute } from '@react-navigation/native';
import { useEffect, useMemo, useState } from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import { Platform } from 'utils/platform';

import { SpallaPlayerWebProps as SpallaPlayerProps } from '.';
import SpallaPlayerCTV from '../SpallaPlayerCTV';
import { usePlayer } from '../context';

import useSuperiorNavbar from 'components/Header/helpers/useSuperiorNavbar';
import SpallaPlayerWeb from 'components/Player/SpallaPlayer';

const SpallaPlayerPlatform: React.FC<SpallaPlayerProps> = (props) => {
  const [isLandscape, setIsLandscape] = useState(false);
  const { width, height } = useWindowDimensions();
  const { isFullScreen } = usePlayer();
  const route = useRoute();
  const hasSuperiorNavbar = useSuperiorNavbar(route);

  const marginTop = useMemo(() => {
    const marginTopForMobileWeb = Platform.isMobileWeb() ? 45 : 80;

    if (isFullScreen) return 0;

    return hasSuperiorNavbar ? marginTopForMobileWeb + 40 : marginTopForMobileWeb;
  }, [isFullScreen, hasSuperiorNavbar]);

  useEffect(() => {
    if (!Platform.isMobileWeb()) return;

    setIsLandscape(width > height);
  }, [width, height]);

  if (Platform.isWebTV) {
    // @ts-ignore
    return <SpallaPlayerCTV {...props} />;
  }

  if (Platform.isMobileWeb) {
    const customStyle = Platform.isMobileWeb()
      ? {
          marginTop: isFullScreen ? 0 : marginTop,
          ...(!isLandscape ? styles.container : undefined),
        }
      : undefined;

    return (
      <View style={customStyle}>
        <SpallaPlayerWeb {...props} />
      </View>
    );
  }

  return <SpallaPlayerWeb {...props} />;
};

const styles = StyleSheet.create({
  container: {
    position: 'sticky' as any,
    top: 45,
    zIndex: 2,
  },
});
export default SpallaPlayerPlatform;
